module.exports = __webpack_public_path__ + "static/media/trinta-reis-de-coroa-branca.c34f248f.png";